import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
    entity: {
        id: 0,
        numero: 0,
        cantidad: 0,
        cantidadStock: 0,
        idConceptoCobro: 0,
        conceptoCobro: "",
        precioUnitario: 0.0,
        subTotal: 0.0,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listConceptoCobro: [{id: 0, descripcion: ""}],
    validationActive: {
        cantidad: false,
        idConceptoCobro: false,
        subTotal: false,
    },
    validationMessage: [],
  }
  
  export const receiptDetailSlice = createSlice({
    name: "receiptDetail",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        var { sliceKey, name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        
        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setListConceptoCobro: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listConceptoCobro = data;
      },
      setValidationMessage: (state, action) => {
        const {sliceKey, message} = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
          state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });
  
  export const { init, setEntity, setData, setValidationMessage, activeValidations
    , setListConceptoCobro
    } = receiptDetailSlice.actions;
  export const defaultReceiptDetail = {
    id: 0,
    numero: 0,
    cantidad: 0,
    cantidadStock: 0,
    idConceptoCobro: 0,
    conceptoCobro: "",
    precioUnitario: 0.0,
    subTotal: 0.0,
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
  }
  export default receiptDetailSlice.reducer;
  